import { useEffect, useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import classesK from '../kalkulatori.module.css'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'

const calculatorType = 'Procena tacnog rezultata'

const ProcenaTacnogRezultata = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      kOdds: ['', '', ''],
      gOdds: ['', ''],
      stats: ['', '', '', '', '', ''],
    },

    results: {
      resultsK: ['', '', ''],
      doubleChance: ['', '', ''],
      resultsG: ['', '', ''],
      exactScore: {
        min: { decimal: '', rounded: '' },
        average: { decimal: '', rounded: '' },
        max: { decimal: '', rounded: '' },
        results: {
          min: { decimal: '', rounded: '' },
          average: { decimal: '', rounded: '' },
          max: { decimal: '', rounded: '' },
        },
      },
      teamStrength: {
        home: {
          attack: '',
          defense: '',
        },
        away: {
          attack: '',
          defense: '',
        },
        combined: {
          attack: '',
          defense: '',
        },
        matchup: {
          homeAttack_vs_awayDefense: '',
          homeDefense_vs_awayAttack: '',
        },
      },
    },
  })
  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        kOdds: ['', '', ''],
        gOdds: ['', ''],
        stats: ['', '', '', '', '', ''],
      },

      results: {
        resultsK: ['', '', ''],
        doubleChance: ['', '', ''],
        resultsG: ['', '', ''],
        exactScore: {
          min: { decimal: '', rounded: '' },
          average: { decimal: '', rounded: '' },
          max: { decimal: '', rounded: '' },
          results: {
            min: { decimal: '', rounded: '' },
            average: { decimal: '', rounded: '' },
            max: { decimal: '', rounded: '' },
          },
        },
        teamStrength: {
          home: {
            attack: '',
            defense: '',
          },
          away: {
            attack: '',
            defense: '',
          },
          combined: {
            attack: '',
            defense: '',
          },
          matchup: {
            homeAttack_vs_awayDefense: '',
            homeDefense_vs_awayAttack: '',
          },
        },
      },
    })
    setShowInputArea(true)
  }
  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    } else {
      handleCalculate()
    }

    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  const handleCalculate = () => {
    const [outcome1, outcomeX, outcome2] = data.values.kOdds.map(Number)
    const [odds02Goals, odds3PlusGoals] = data.values.gOdds.map(Number)
    const [
      homeScored,
      homeConceded,
      homeGamesPlayed,
      awayScored,
      awayConceded,
      awayGamesPlayed,
    ] = data.values.stats.map(Number)

    const I70 = (1 / odds02Goals) * 100
    const J70 = (1 / odds3PlusGoals) * 100
    const K70 = I70 + J70
    const L70 = K70 - 100
    const M70 = L70 / 2
    const N70 = I70 - M70
    const O70 = J70 - M70

    const P70 = () => {
      if (N70 < 0) {
        return 0
      } else {
        return N70
      }
    }

    const Q70 = () => {
      if (O70 < 0) {
        return 0
      } else {
        return O70
      }
    }

    const B23 = homeScored / homeGamesPlayed
    const F23 = awayConceded / awayGamesPlayed
    const H23 = awayScored / awayGamesPlayed
    const T66 =
      (homeConceded + awayConceded) / (homeGamesPlayed + awayGamesPlayed)
    const T64 = (homeScored + awayScored) / (homeGamesPlayed + awayGamesPlayed)
    const R70 = (Q70() * 5) / 100
    const S66 = (R70 * 2 * 25) / 100
    const S70 = B23
    const U70 = F23
    const V70 = H23
    const R68 = R70 - S66
    const T68 = Math.min(T64, T66)
    const W59 = (R68 + T68) / 2
    const X59 = () => {
      if (W59 >= 5) {
        return W59 - (W59 * 3.12) / 100
      } else if (W59 >= 4) {
        return W59 - (W59 * 2.14) / 100
      } else if (W59 >= 3) {
        return W59 - (W59 * 1.21) / 100
      } else if (W59 >= 2) {
        return W59 + (W59 * 1.16) / 100
      } else if (W59 < 2) {
        return W59 + (W59 * 1.11) / 100
      }
    }

    let SND = (homeScored / homeGamesPlayed).toFixed(2)
    let SOD = (homeConceded / homeGamesPlayed).toFixed(2)
    let SOG = (awayConceded / awayGamesPlayed).toFixed(2)
    let SNG = (awayScored / awayGamesPlayed).toFixed(2)
    let SODG = ((parseFloat(SOD) + parseFloat(SOG)) / 2).toFixed(2)
    let SNDG = ((B23 + H23) / 2).toFixed(2)
    let SNDSOG = ((B23 + F23) / 2).toFixed(2)
    let SODSNG = ((parseFloat(SOD) + parseFloat(SNG)) / 2).toFixed(2)

    const R72 = R70 + S66
    const T72 = Math.max(T64, T66)

    const W63 = (R72 + T72) / 2

    const X63 = () => {
      if (W63 >= 5) {
        return W63 - (W63 * 3.12) / 100
      } else if (W63 >= 4) {
        return W63 - (W63 * 2.14) / 100
      } else if (W63 >= 3) {
        return W63 - 1.21 / 100
      } else if (W63 >= 2) {
        return W63 + (W63 * 1.16) / 100
      } else if (W63 < 2) {
        return W63 + (W63 * 1.11) / 100
      }
    }

    const W68 = X59()
    const W72 = X63()

    const C74 = outcome1
    const D74 = outcomeX
    const E74 = outcome2

    const F74 = (1 / C74) * 100
    const G74 = (1 / D74) * 100
    const H74 = (1 / E74) * 100
    const I74 = F74 + G74 + H74 - 100
    const J74 = F74 - I74 / 3
    const K74 = G74 - I74 / 3
    const L74 = H74 - I74 / 3
    const M74 = (J74 * I74) / 100
    const N74 = (K74 * I74) / 100
    const O74 = (L74 * I74) / 100
    const P74 = F74 - M74
    const Q74 = G74 - N74
    const R74 = H74 - O74
    const S74 = P74 + Q74 / 2
    const T74 = 100 - S74

    let W70Second = (W68 + W72) / 2

    const Y70 = (W70Second * S74) / 100

    const Z70 = (W70Second * T74) / 100

    const AA70 = (Y70 * 45) / 100
    const AB70 = (Z70 * 45) / 100

    const AC70 = () => {
      if (Y70 < 0) {
        return 0
      } else {
        return Math.round(Y70)
      }
    }

    const AD70 = () => {
      if (Z70 < 0) {
        return 0
      } else {
        return Math.round(Z70)
      }
    }

    const AE70 = () => {
      if (AA70 < 0) {
        return 0
      } else {
        return Math.round(AA70)
      }
    }

    const AF70 = () => {
      if (AB70 < 0) {
        return 0
      } else {
        return Math.round(AB70)
      }
    }

    const AH70 = () => {
      if (Y70 < 0) {
        return 0
      } else {
        return Y70
      }
    }

    const AI70 = () => {
      if (Z70 < 0) {
        return 0
      } else {
        return Z70
      }
    }

    const AJ70 = () => {
      if (AA70 < 0) {
        return 0
      } else {
        return AA70
      }
    }

    const AK70 = () => {
      if (AB70 < 0) {
        return 0
      } else {
        return AB70
      }
    }
    // console.log(W68, S74);
    const Y68 = (W68 * S74) / 100

    const Z68 = (W68 * T74) / 100
    const AA68 = Y68 * 0.45
    const AB68 = (Z68 * 45) / 100
    const AC68 = () => {
      if (Y68 < 0) {
        return 0
      } else {
        return parseFloat(Y68).toFixed(0)
      }
    }

    const AD68 = () => {
      if (Z68 < 0) {
        return 0
      } else {
        return parseFloat(Z68).toFixed(0)
      }
    }

    const AE68 = () => {
      if (AA68 < 0) {
        return 0
      } else {
        return parseFloat(AA68).toFixed(0)
      }
    }

    const AF68 = () => {
      if (AB68 < 0) {
        return 0
      } else {
        return parseFloat(AB68).toFixed(0)
      }
    }

    const AH68 = () => {
      if (Y68 < 0) {
        return 0
      } else {
        return Y68
      }
    }

    const AI68 = () => {
      if (Z68 < 0) {
        return 0
      } else {
        return Z68
      }
    }

    const AJ68 = () => {
      if (AA68 < 0) {
        return 0
      } else {
        return AA68
      }
    }

    const AK68 = () => {
      if (AB68 < 0) {
        return 0
      } else {
        return AB68
      }
    }

    const Y72 = (W72 * S74) / 100
    const Z72 = (T74 * W72) / 100
    const AA72 = (Y72 * 45) / 100
    const AB72 = (Z72 * 45) / 100
    const AC72 = () => {
      if (Y72 < 0) {
        return 0
      } else {
        return Math.round(Y72)
      }
    }

    const AD72 = () => {
      if (Z72 < 0) {
        return 0
      } else {
        return Math.round(Z72)
      }
    }

    const AE72 = () => {
      if (AA72 < 0) {
        return 0
      } else {
        return Math.round(AA72)
      }
    }

    const AF72 = () => {
      if (AB72 < 0) {
        return 0
      } else {
        return Math.round(AB72)
      }
    }

    const AH72 = () => {
      if (Y72 < 0) {
        return 0
      } else {
        return Y72
      }
    }

    const AI72 = () => {
      if (Z72 < 0) {
        return 0
      } else {
        return Z72
      }
    }

    const AJ72 = () => {
      if (AA72 < 0) {
        return 0
      } else {
        return AA72
      }
    }

    const AK72 = () => {
      if (AB72 < 0) {
        return 0
      } else {
        return AB72
      }
    }

    const P77 = P74 + Q74
    const Q77 = P74 + R74
    const R77 = Q74 + R74

    const L31 = (R70 + S70 + parseFloat(SOD) + U70 + V70 + W70Second) / 6

    setData((prev) => ({
      ...prev,
      results: {
        resultsK: [P74.toFixed(2), Q74.toFixed(2), R74.toFixed(2)],
        doubleChance: [P77.toFixed(2), Q77.toFixed(2), R77.toFixed(2)],
        resultsG: [P70().toFixed(2), (100 - P70()).toFixed(2), L31.toFixed(2)],
        exactScore: {
          min: {
            decimal: `${AH68().toFixed(2)} : ${AI68().toFixed(
              2
            )}\n( ${AJ68().toFixed(2)} : ${AK68().toFixed(2)} )`,
            rounded: `${Math.round(AC68())} : ${Math.round(
              AD68()
            )}\n( ${Math.round(AE68())} : ${Math.round(AF68())} )`,
          },
          average: {
            decimal: `${AH70().toFixed(2)} : ${AI70().toFixed(
              2
            )}\n( ${AJ70().toFixed(2)} : ${AK70().toFixed(2)} )`,
            rounded: `${Math.round(AC70())} : ${Math.round(
              AD70()
            )}\n( ${Math.round(AE70())} : ${Math.round(AF70())} )`,
          },
          max: {
            decimal: `${AH72().toFixed(2)} : ${AI72().toFixed(
              2
            )}\n( ${AJ72().toFixed(2)} : ${AK72().toFixed(2)} )`,
            rounded: `${Math.round(AC72())} : ${Math.round(
              AD72()
            )}\n( ${Math.round(AE72())} : ${Math.round(AF72())} )`,
          },
        },
        teamStrength: {
          home: {
            attack: SND,
            defense: SOD,
          },
          away: {
            attack: SNG,
            defense: SOG,
          },
          combined: {
            attack: SNDG,
            defense: SODG,
          },
          matchup: {
            homeAttack_vs_awayDefense: SNDSOG,
            homeDefense_vs_awayAttack: SODSNG,
          },
        },
      },
    }))
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upisi kvote za ishod utakmice
            </div>
            <OddsCalculator
              field={'kOdds'}
              data={data.values}
              setData={setData}
              labelPrefix={['KI 1', 'KI X', 'KI 2']}
              step={['0.1', '0.1', '0.1']}
              min={['0.1', '0.1', '0.1']}
              type={['number', 'number', 'number']}
              setError={setError}
              rows={3}
            />
            <div className={classesK.sectionTitle}>Upiši kvote za golove</div>
            <OddsCalculator
              field={'gOdds'}
              data={data.values}
              setData={setData}
              labelPrefix={['Manje od 2.5 ( UG 0-2 )', 'Više od 2.5 ( UG 3+ )']}
              rows={2}
              type={['number', 'number']}
              step={['0.1', '0.1']}
              min={['0.1', '0.1']}
              setError={setError}
            />
            <div className={classesK.sectionTitle}>
              Upiši br. golova / br. ut. za oba tima
            </div>
            <OddsCalculator
              field={'stats'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'DOM +  ( dom. dao golova)',
                'DOM -  ( dom. primio golova)',
                'DOM BR. ( dom. odigrao utakmica)',
                'GOST +  ( gost. dao golova)',
                'GOST -  ( gost. primio golova)',
                'GOST BR. ( gost. odigrao utakmica)',
              ]}
              type={[
                'number',
                'number',
                'number',
                'number',
                'number',
                'number',
              ]}
              step={['1', '1', '1', '1', '1', '1']}
              min={['0', '0', '1', '0', '0', '1']}
              rows={3}
              setError={setError}
            />
          </>
        )}
        {!showInputArea && (
          <div className={classesK.sectionResults}>
            <ResultsSection
              title={`Ishod utakmice`}
              subtitle={`Konačan ishod`}
              withPercent={true}
              results={data?.results?.resultsK.map((result) => `${result}%`)}
              names={['KI 1', 'KI X', 'KI 2']}
            />
            <ResultsSection
              title={'Dupla šansa'}
              subtitle={`Dvoznak`}
              withPercent={true}
              results={data?.results?.doubleChance.map(
                (result) => `${result}%`
              )}
              names={['KI 1X', 'KI 12', 'KI X2']}
            />
            <ResultsSection
              title={'Golovi'}
              subtitle={`Ukupno golova`}
              results={data?.results?.resultsG.map((result, index) =>
                index < 2 ? `${result}%` : result
              )}
              names={[
                'Manje od 2.5 ( UG 0-2 )',
                'Više od 2.5 ( UG 3+ )',
                'Gol prosek ( srednja predikcija )',
              ]}
            />
            <ResultsSection
              title={'Tačan rezultat'}
              subtitle={`Minimalan tačan rezultat`}
              results={[
                data.results?.exactScore?.min?.decimal,
                data.results?.exactScore?.min?.rounded,
              ]}
              withPercent={false}
              names={['Decimalan prikaz', 'Prikaz u celom broju']}
            />
            <ResultsSection
              subtitle={`Srednji tačan rezultat`}
              results={[
                data.results?.exactScore?.average?.decimal,
                data.results?.exactScore?.average?.rounded,
              ]}
              withPercent={false}
              names={['Decimalan prikaz', 'Prikaz u celom broju']}
            />
            <ResultsSection
              subtitle={`Maksimalan tačan rezultat`}
              results={[
                data.results?.exactScore?.max?.decimal,
                data.results?.exactScore?.max?.rounded,
              ]}
              withPercent={false}
              names={['Decimalan prikaz', 'Prikaz u celom broju']}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={`Snaga domaćina`}
              results={[
                data.results?.teamStrength?.home?.attack,
                data.results?.teamStrength?.home?.defense,
              ]}
              withPercent={false}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={`Snaga gosta`}
              results={[
                data.results?.teamStrength?.away?.attack,
                data.results?.teamStrength?.away?.defense,
              ]}
              withPercent={false}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={`Snage oba tima zajedno`}
              results={[
                data.results?.teamStrength?.combined?.attack,
                data.results?.teamStrength?.combined?.defense,
              ]}
              withPercent={false}
              names={[
                'SNDG ( snaga napada domaćina i gosta )',
                'SODG ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={`Tim proseci odbrana i napada`}
              results={[
                data.results?.teamStrength?.matchup?.homeAttack_vs_awayDefense,
                data.results?.teamStrength?.matchup?.homeDefense_vs_awayAttack,
              ]}
              withPercent={false}
              names={[
                'SND + SOG ( dom.daje/gost prima )',
                'SOD + SNG ( dom. prima/gost daje )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProcenaTacnogRezultata
